import { Component, input } from '@angular/core';

@Component({
  selector: 'app-message-icon',
  template: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path [attr.d]="paths[name()] || paths['info']" /></svg>`,
  styles: [':host { display: inline-flex; width: 1.25em; height: 1.25em; flex-shrink: 0; vertical-align: middle; } svg { width: 100%; height: 100%; }'],
})
export class MessageIconComponent {
  readonly name = input('info');
  readonly paths: Record<string, string> = {
    close: 'M6 6l12 12M6 18 18 6',
    arrow_forward: 'M4 12h16m-6-6 6 6-6 6',
    done: 'm5 12 4 4L19 6',
    check_circle: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM7 12l3 3 7-7',
    task_alt: 'M22 12a10 10 0 1 1-5-8.7M7 12l3 3L22 3',
    error: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM12 7v6m0 4h.01',
    error_outline: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM12 7v6m0 4h.01',
    warning: 'M12 3 2 21h20L12 3ZM12 9v5m0 3h.01',
    info: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM12 11v6m0-10h.01',
    forum: 'M21 11V4H3v12h4v5l5-5h9v-5ZM7 8h10M7 12h6',
  };
}
